module.exports = __webpack_public_path__ + "img/fi-rr-calendar.b4053a48.svg";